import { useEffect } from 'react'
import { useParams } from 'react-router-dom-v5-compat'

import { useAuthenticatedUser } from '@sparkai/auth'
import services from '@sparkai/services/spark'

import { ShareLinkAccessState } from './ShareLinkAccessState'

export function RequestDetails() {
  const { requestId } = useParams<'requestId'>()
  const { data: engagementId, error, isPending } = services.engagement.v3.getByRequestId(requestId)
  const { profile } = useAuthenticatedUser()

  const origin =
    profile?.role === 'admin' ? `${window.location.origin}/admin` : `${window.location.origin}/customer`

  useEffect(() => {
    if (isPending || !profile) return

    if (!engagementId || error) {
      window.location.href = `${origin}/invalid-request-id?requestId=${requestId}`
    } else {
      window.location.href = `${origin}/engagement/${engagementId}`
    }
  }, [engagementId, isPending, origin, error, requestId])

  return <ShareLinkAccessState state='loading' />
}
